































import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { aspergersUrl, linkedIn, emailAddress, linkedInLiteral, resumeUrl } from '@/data';
import { IPersona, IPdfUrl } from '@/@types';
import LinkedInIconVue from '@/components/LinkedInIcon.vue';

const cssName = 'header';
const personaModule = namespace('persona');

@Component({
  components: {
    LinkedInIconVue,
  },
})
export default class AppHeader extends Vue {
  public aspergersUrl: string = aspergersUrl;
  public emailAddress: string = emailAddress;
  public linkedIn: string = linkedIn;
  public linkedInLiteral: string = linkedInLiteral;
  public resumeUrl: string = resumeUrl;
  public yearsIn: number = moment().diff(moment('19981001'), 'years');

  @personaModule.Getter('isPersonaDeveloper') public isPersonaDeveloper!: boolean;
  @personaModule.Getter('isPersonaFounder') public isPersonaFounder!: boolean;
  @personaModule.Getter('isPersonaMaker') public isPersonaMaker!: boolean;
  @personaModule.Getter('pdfUrl') public pdfUrl!: IPdfUrl;
  @personaModule.State('currentPersona') public currentPersona!: IPersona;

  public get cssClass(): object {
    return {
      [cssName]: true,
      [`${cssName}--developer`]: this.isPersonaDeveloper,
      [`${cssName}--maker`]: this.isPersonaMaker,
      [`${cssName}--founder`]: this.isPersonaFounder,
    };
  }

  get emailHref(): string {
    return `mailto:${emailAddress}`;
  }

  get url(): string {
    return `${this.resumeUrl}/#${this.currentPersona.slug}`;
  }
}
